import { X } from 'lucide-react'
import { IconButton } from '../common/primitives/IconButton'
import styles from './Patterns.module.css'

export function Inspector({ title, children, footer, onClose, closeLabel = 'Close details', className = '' }) {
  return (
    <aside className={`${styles.inspector} ${className}`.trim()} aria-label={title || 'Details'}>
      {(title || onClose) ? <header className={styles.inspectorHeader}>{title ? <h2 className={styles.inspectorTitle}>{title}</h2> : null}{onClose ? <IconButton variant="ghost" label={closeLabel} onClick={onClose}><X size={18} aria-hidden="true" /></IconButton> : null}</header> : null}
      <div className={styles.inspectorBody}>{children}</div>
      {footer ? <footer className={styles.inspectorFooter}>{footer}</footer> : null}
    </aside>
  )
}
